module.exports = __webpack_public_path__ + "media/images/new_culture/bg-4-2013337256570c954b3d7d7e692ffbe4.jpeg";